import { useState, useEffect } from 'react';

import axios from 'axios';
import routes from 'app/routes';

export default function useEnterprise(enterpriseId) {
  const [enterprise, setEnterprise] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.enterprises.show(enterpriseId))
      .then((response) => {
        setEnterprise(response.data.data);
      });
  }, [enterpriseId]);

  return enterprise;
}
